import _ from 'lodash';
import moment from 'moment';

export type Options = {
	fileName: string;
	fields: Field[];
	title?: string[];
	filterBy?: (data: any) => boolean;
};

interface Field {
	name: string;
	header?: string;
	apply?: (value: any) => string;
}

export const downloadCsv = (data: any[], options: Options) => {
	const blob = createBlob(
		createTitle(options.title),
		createHeaders(options.fields),
		createCsvData(filterData(data, options.filterBy), options.fields)
	);

	// @ts-ignore
	if (window.navigator.msSaveOrOpenBlob)
		window.navigator.msSaveBlob(blob, createFileName(options.fileName));
	else {
		const a = window.document.createElement('a');
		// @ts-ignore
		a.href = window.URL.createObjectURL(blob);
		a.download = createFileName(options.fileName);
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	}
};

const createTitle = (title: string[] | undefined): string =>
	title ? _.join(title, '\r\n').concat('\r\n\r\n') : '';

const createHeaders = (fields: Field[]) =>
	fields
		.map(f => (f.header ? f.header : _.startCase(f.name)))
		.join(',')
		.concat('\n');

const filterData = (data: any[], filterBy?: (item: any) => boolean): any[] =>
	filterBy ? data.filter(filterBy) : data;

const createCsvData = (data: any[], fields: Field[]): string => {
	const result = data.map((d: any) =>
		fields.map((f: Field) => {
			const value = _.get(d, f.name);
			const formatted = f.apply ? f.apply(value) : value;
			return typeof formatted === 'string' ? `"${formatted}"` : value;
		})
	);
	return _.join(result, '\r\n');
};

const createBlob = (title: string, headers: string, data: string): Blob =>
	new Blob([`${title}${headers}${data}`]);

const createFileName = (name: string) =>
	`${name}_${moment().format('YYYY-MM-DD')}.csv`;
